export enum ChoiceType {
  Multiple = 'Multiple',
  SingleRequired = 'SingleRequired',
  SingleOptional = 'SingleOptional',
}
